module.exports = __webpack_public_path__ + "static/media/IconTemplates_-59.9574e697.svg";